import { EmbeddedResourceModel } from './EmbeddedResourceModel';
import { IHasId } from './IHasId';
import { ReactBundleModel } from './ReactBundleModel';
import { SharedComponentModel } from './SharedComponentModel';
import { ViewModel } from './ViewModel';

export const DEFAULT_PHONE_NUMBER_FORMAT = '(###) ###-####';
export const DEFAULT_CURRENCY_CODE = 'USD';
export const LEGACY_DEFAULT_THEME_ID = '00000000-0000-0000-0000-000000000000';

export type BundleTheme = {
	Id: string;
	Name: string;
	IsDefault: boolean;
	Theme?: Record<string, any>;
};

export type Bundle = IHasId & {
	Name: string;
	Description?: string;
	/** Legacy single theme, accepted when opening older App definitions. */
	Theme?: Record<string, any>;
	Themes?: BundleTheme[];
	Settings?: {
		AnonymousIdentityStorage?: 'SessionStorage' | 'LocalStorage' | 'Memory';
		AllowFileReads?: boolean;
		AllowFileUploads?: boolean;
		PhoneNumberFormat?: string;
		CurrencyCode?: string;
	};
	EmbeddedResources: EmbeddedResourceModel[];
	SharedComponents: SharedComponentModel[];
	ReactBundle?: ReactBundleModel;
	Views: ViewModel[];
};

export function withDefaultBundleSettings(bundle: Bundle): Bundle {
	const sourceThemes = bundle.Themes?.length
		? bundle.Themes
		: [{ Id: LEGACY_DEFAULT_THEME_ID, Name: 'Default', IsDefault: true, Theme: bundle.Theme }];
	const defaultThemeIndex = Math.max(
		0,
		sourceThemes.findIndex((theme) => theme.IsDefault),
	);
	const themes = sourceThemes.map((theme, index) => ({
		...theme,
		Id: theme.Id || (index === 0 ? LEGACY_DEFAULT_THEME_ID : crypto.randomUUID()),
		Name: theme.Name?.trim() || (index === 0 ? 'Default' : `Theme ${index + 1}`),
		IsDefault: index === defaultThemeIndex,
	}));

	return {
		...bundle,
		Theme: undefined,
		Themes: themes,
		Settings: {
			...bundle.Settings,
			PhoneNumberFormat: bundle.Settings?.PhoneNumberFormat ?? DEFAULT_PHONE_NUMBER_FORMAT,
			CurrencyCode: bundle.Settings?.CurrencyCode ?? DEFAULT_CURRENCY_CODE,
		},
	};
}
